export const formatPhoneNumber = (phoneNumber: string) => {
  const phoneStr = String(phoneNumber)

  if (phoneStr.length === 11 && phoneStr.startsWith('7')) {
    const lastFour = phoneStr.slice(-4)
    const formattedNumber = `+7-XXX-XXX-${lastFour}`

    return formattedNumber
  }

  return 'Некорректный формат номера'
}

export const cleanPhoneNumber = (formattedPhone: string): string => {
  return formattedPhone.replace(/\D/g, '')
}
